import { useId, type InputHTMLAttributes } from "react";

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, "className" | "id"> {
  rotulo: string;
  erro?: string;
  /** Texto de apoio. Some quando há erro — dois textos abaixo do campo
   * competem, e o que importa nesse momento é o erro. */
  ajuda?: string;
}

export function Campo({ rotulo, erro, ajuda, required, ...resto }: Props) {
  const id = useId();
  const idErro = `${id}-erro`;
  const idAjuda = `${id}-ajuda`;
  const temErro = Boolean(erro);

  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={id} className="font-texto text-caption text-texto-suave">
        {rotulo}
        {required === true && (
          <span aria-hidden="true" className="ml-1 text-carmim">
            *
          </span>
        )}
      </label>

      <input
        {...resto}
        id={id}
        required={required}
        aria-invalid={temErro}
        aria-describedby={temErro ? idErro : ajuda !== undefined ? idAjuda : undefined}
        className={[
          // `rounded-md` é o mesmo raio do `Botao` e do `Selecao`: numa linha
          // de formulário os três aparecem lado a lado, e cantos diferentes
          // fazem o conjunto parecer montado por partes.
          "h-10 rounded-md border bg-superficie px-3 font-texto text-body text-texto",
          "placeholder:text-texto-tenue",
          "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1",
          "focus-visible:outline-acao-viva",
          "disabled:cursor-not-allowed disabled:opacity-55",
          temErro ? "border-carmim" : "border-borda",
        ].join(" ")}
      />

      {temErro ? (
        // `role="alert"` para o leitor de tela anunciar sem que a pessoa
        // precise voltar ao campo.
        <p id={idErro} role="alert" className="font-texto text-caption text-carmim">
          {erro}
        </p>
      ) : (
        ajuda !== undefined && (
          <p id={idAjuda} className="font-texto text-caption text-texto-tenue">
            {ajuda}
          </p>
        )
      )}
    </div>
  );
}
